import React from "react"
import {ValidationProps, ValidationState} from "./Input"

interface Component<T = any> extends React.Component<ValidationProps<T>, ValidationState<T>> {}
interface PureComponent<T = any> extends React.PureComponent<ValidationProps<T>, ValidationState<T>> {}

/**
 * @author: Michael 31/8/2018
 * @desc: This is so validation still works where i18n is being used, validation is no longer set in defaultProps but
 * in the state, hence this fallback.
 */
export default function getValidation<SchemaType = any>(component: Component<SchemaType> | PureComponent<SchemaType>) {
  return component.props.validation || component.state.validation
}
